import { useState } from "react";
import { faqs } from "@/mocks/comics";

export default function FAQ() {
  const [openIdx, setOpenIdx] = useState<number | null>(0);

  return (
    <section id="faq" className="bg-background-50 py-16 md:py-24">
      <div className="mx-auto max-w-7xl px-4 md:px-6">
        <div className="grid grid-cols-1 gap-10 lg:grid-cols-5">
          <div className="lg:col-span-2">
            <span className="inline-flex items-center gap-2 rounded-full bg-accent-100 px-3 py-1 text-sm font-semibold text-accent-700">
              <i className="ri-question-line"></i> 常见问题
            </span>
            <h2 className="mt-3 font-heading text-3xl text-foreground-950 md:text-4xl">追更路上的疑问，一次说清</h2>
            <p className="mt-4 max-w-sm text-sm leading-relaxed text-foreground-600">
              关于追更进度、热门榜单、周更安排与账号同步的常见问题。没找到答案？欢迎随时联系我们。
            </p>
            <a
              href="#contact"
              className="mt-6 inline-flex items-center gap-2 whitespace-nowrap rounded-full bg-primary-500 px-5 py-2.5 text-sm font-semibold text-background-50 transition-colors hover:bg-primary-600"
            >
              <i className="ri-customer-service-2-line"></i> 联系客服
            </a>
          </div>

          <div className="lg:col-span-3">
            <div className="divide-y divide-background-200/80 overflow-hidden rounded-2xl bg-background-50">
              {faqs.map((faq, i) => (
                <div key={faq.q}>
                  <button
                    type="button"
                    onClick={() => setOpenIdx(openIdx === i ? null : i)}
                    className="flex w-full items-center justify-between gap-4 px-5 py-5 text-left"
                    aria-expanded={openIdx === i}
                  >
                    <h3 className="text-base font-bold text-foreground-950">{faq.q}</h3>
                    <span
                      className={`flex h-8 w-8 shrink-0 items-center justify-center rounded-full bg-background-100 text-primary-600 transition-transform duration-300 ${
                        openIdx === i ? "rotate-45" : ""
                      }`}
                    >
                      <i className="ri-add-line text-lg"></i>
                    </span>
                  </button>
                  <div
                    className={`grid transition-all duration-300 ${
                      openIdx === i ? "grid-rows-[1fr] opacity-100" : "grid-rows-[0fr] opacity-0"
                    }`}
                  >
                    <div className="overflow-hidden">
                      <p className="px-5 pb-5 text-sm leading-relaxed text-foreground-600">{faq.a}</p>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}